import { Component, inject } from '@angular/core';
import {
    TranslationsService,
} from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { values } from 'ramda';

export interface EnumRendererValue {
    value: string | string[];
    type: string;
}

@Component({
    selector: 'wdx-ag-grid-enum-cell-renderer',
    template: '<div>{{ translatedKey }}</div>',
})
export class EnumRendererComponent implements ICellRendererAngularComp {
    private translationService = inject(TranslationsService);
    public translatedKey?: string;

    public agInit(params: ICellRendererParams<any, EnumRendererValue>): void {
        const { value, type } = params?.value || {};
        if (!type || !value || typeof type !== 'string') {
            return;
        }

        const toTranslatedKey = (v: string) =>
            this.translationService.translateTokenisedString(
                `ENUM_${type.toUpperCase()}_${v.toUpperCase()}`,
            );

        if (typeof value === 'string') {
            this.translatedKey = toTranslatedKey(value);
        } else if (Array.isArray(value)) {
            this.translatedKey = value.map(toTranslatedKey).join(', ');
        }
    }

    public refresh(
        params: ICellRendererParams<any, EnumRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }
}
